import { ApiResourcePaths } from "../../../apiRoutes";
import { UpdateGroupDto } from "../../../models/domain/UpdateGroupDto";
import { ApiResourceTableProps } from "../../../comps/api-resource-table/ApiResourceTable";
import { UpdateGroupFarmDto } from "../../../models/domain/UpdateGroupFarmDto";
import {IdExtraParams, useApiClient} from "../../../hooks/useApiClient";
import { UpdateGroupAvailableFarmsColumnsFactory } from "./UpdateGroupAvailableFarmsColumnsFactory";
import { useEffect, useState } from "react";
import { useDataShaper } from "../../../core/table/useDataShaper";
import { UpdateGroupFarmConfig } from "./UpdateGroupFarmConfig";
import { getShapedData } from "../../../core/table/GetShapedData";
import { getShapingFromTable } from "../../../core/table/GetShapingFromTable";
import { PageInfoDto } from "../../../models/domain/pagination/PageInfoDto";
import { useApiResourceTable } from "../../../hooks/useApiResourceTable";
import { NoRefetchQueryOptions } from "../../../comps/api-resource-table/ApiResourceTableDefaults";

export const useUpdateGroupAvailableFarmsProfile =
  (updateGroup: UpdateGroupDto | undefined): ApiResourceTableProps<UpdateGroupFarmDto> => {
  const apiClient = useApiClient();
  const [overrideData, setOverrideData] = useState<PageInfoDto<UpdateGroupFarmDto>>();

  const table = useApiResourceTable<UpdateGroupFarmDto, IdExtraParams>({
    requestFn: apiClient.updateGroup.farm.listAvailable,
    queryExtraParams: () => ({id: !!updateGroup?.id ? updateGroup.id : 0}),
    queryKeyFn: () => ApiResourcePaths.updateGroupAvailableFarms(null, updateGroup?.id),
    columnFactory: UpdateGroupAvailableFarmsColumnsFactory(updateGroup),
    queryOptions: {
      ...NoRefetchQueryOptions,
      enabled: !!updateGroup?.id,
      placeholderData: prev => prev,
    },
    mrtParams: {
      initialSorting: [{id: "updateGroupId", desc: true}]
    }
  });

  const shaper = useDataShaper(UpdateGroupFarmConfig, getShapingFromTable(table))

  const { data } = table.query;

  useEffect(() => setOverrideData(getShapedData(data, shaper)),
    [data, setOverrideData, shaper]);

  return {
    ...table,
    overrideData,
    tableProps: {
      state: {
        density: "compact"
      },
      manualSorting: true,
      manualFiltering: true,
      manualPagination: true,
    }
  };
}